import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from 'components/drawer';
import PinInput from 'components/pin-input';
import DateInput from 'components/date-picker';
import {
  fetchAccounts,
  lookupSettlement,
  withdrawSettlement,
} from 'store/actions/cashout';
import Button from 'components/button';
import styles from './modal.module.scss';
import CustomSelect from 'components/common/CustomSelect';
import SuccessModal from 'components/SuccessModal';
import SuccessGif from 'assets/animations/gifs/success.gif';
import { formatCurrency } from 'libs/utils';
import moment from 'moment';

const WithdrawModal = ({ drawerActive, setDrawerActive }) => {
  const [loading, setLoading] = useState(false);
  const { handleSubmit, errors, register } = useForm();

  const withdrawalAccounts = useSelector((state) => state.cashout.details);

  const accounts =
    withdrawalAccounts?.list?.map((item) => {
      return {
        id: item.id,
        text: `${item.accountName} (${item.bankName}, ${item.accountNumber})`,
      };
    }) || [];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAccounts());
  }, [dispatch]);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [account, setAccount] = useState('');
  const [settlementAmount, setSettlementAmount] = useState(0);
  const [settlementPassword, setSettlementPassword] = useState('');
  const [accountError, setAccountError] = useState('');
  const [modal, setModal] = useState(false);

  useEffect(() => {
    setSettlementAmount(0);
    if (startDate === '' || endDate === '') return;
    const date = {
      from: new Date(startDate).toISOString(),
      to: new Date(endDate).toISOString(),
    };

    dispatch(lookupSettlement(date, setSettlementAmount));
  }, [startDate, endDate, dispatch]);

  const onSubmit = (values) => {
    if (
      startDate === '' ||
      endDate === '' ||
      account === '' ||
      settlementPassword === ''
    )
      return;
    setLoading(true);
    const onSuccess = () => {
      setDrawerActive(false);
      setModal(true);
      setLoading(false);
    };

    const onFail = () => {
      setLoading(false);
    };

    dispatch(
      withdrawSettlement(
        {
          bankAccountId: account.id,
          from: new Date(startDate).toISOString(),
          to: new Date(endDate).toISOString(),
          settlementPassword,
        },
        onSuccess,
        onFail,
      ),
    );
  };

  const onCloseModal = () => {
    setDrawerActive(false);
    setModal(false);
  };

  return (
    <>
      <Drawer
        title="Withdraw"
        setDrawerActive={setDrawerActive}
        drawerActive={drawerActive}
      >
        <Drawer.DrawerBody>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.withdrawalModalDate}>
              <DateInput
                label="From"
                value={startDate}
                onChange={(value) => setStartDate(value)}
                variant="blue"
              />
              <div className={styles.withdrawalModalDateRight}>
                <DateInput
                  label="To"
                  value={endDate}
                  onChange={(value) => setEndDate(value)}
                  variant="blue"
                  rightAlign
                  type="text"
                />
              </div>
            </div>
            <p className={styles.withdrawalModalAmount}>
              Amount : <span>{formatCurrency(settlementAmount)}</span>
            </p>

            <CustomSelect
              label="Select account to withdraw to"
              name="account"
              options={accounts}
              variant="blue"
              handleClick={(value) => setAccount(value)}
              error={errors.account}
              defaultValue={account}
            />

            <PinInput
              label="PIN"
              placeholder="Enter PIN here"
              name="pin"
              type="password"
              ref={register({
                required: 'Enter your pin',
                minLength: {
                  value: 4,
                  message: 'Invalid pin',
                },
              })}
              error={errors.pin?.message}
              variant="blue"
              onChange={(e) => setSettlementPassword(e.target.value)}
              autoComplete="new-password"
            />

            <Button
              type="submit"
              text="Withdraw"
              variant="primary"
              loading={loading}
              loadingtext="Please wait..."
            />
          </form>
        </Drawer.DrawerBody>
      </Drawer>

      {modal && (
        <SuccessModal
          positiveBtn={onCloseModal}
          negativeBtn={onCloseModal}
          decorationIcon={<img src={SuccessGif} width="150" height="150" />}
          title="Withdrawal successful."
          subtitle="We are going through your request, we will approve shortly."
          buttonText="Close"
        />
      )}
    </>
  );
};

export default WithdrawModal;
